export default {
  heading: "家庭",
  home: {
    error: {
      noEmail: "由於家庭成員帳戶需要有電郵地址，請<a href='{link}'>按此</a>更新個人資料中的登入電郵。",
      functionalAccount: "此家庭功能只供學生會員及公眾會員使用，請更換帳戶再嘗試。",
      studentAccount: "此家庭功能只供學生會員、公眾會員及正式會員使用，請<a href='{link}'>按此</a>升級帳戶為學生會員。",
      cannotCreateOrJoin: "發生問題。",
      full: "家庭成員已滿。",
      expired: "家庭加入超鏈結已過期，請聯繫家庭管理員重新生成",
    },
  },
  index: {
    heading: "建立家庭",
    text: {
      info: "歡迎使用家庭群組服務！",
      info2: "會員加入家庭群組後，家庭成員將能查看其他會員的帳戶資料及活動記錄。",
      studentInfo: "歡迎使用家庭群組服務！",
      hint: "* 一個帳戶只能同時進入一個家庭群組",
      or: "或",
      formInfo: "請輸入家庭資訊",
      recaptcha: "reCAPTCHA 暫時停用",
      createInfo: "建立家庭，並邀請成員加入",
      shareMessage: "您可以透過電郵或WhatsApp邀請家人建立新家庭",
    },
    label: {
      familyName: "家庭名稱",
      nickname: "您的暱稱",
      role: "您的家庭角色",
      submit: "完成",
      back: "返回",
      receiverEmail: "收件人電郵",
      invite: "邀請建立家庭",
    },
    placeholder: {
      nickname: "最多100個字元",
    },
    validation: {
      familyNameIsEmpty: "請輸入家庭名稱。",
      nicknameIsEmpty: "請輸入您的暱稱。",
      roleIsEmpty: "請選擇家庭角色。",
      roleIsInvalid: "家庭角色不正確，請重新選擇。",
      familyNameBadword: "切勿使用不雅用語，請輸入其他家庭名稱。",
      familyNameExceedMax: "請輸入最多100個字元。",
      nicknameBadword: "切勿使用不雅用語，請輸入其他暱稱。",
      nicknameExceedMax: "請輸入最多100個字元。",
      receiverEmailIsEmpty: "請輸入收件人電郵地址。",
      receiverEmailFormatWrong: "電郵地址格式不正確，請重新輸入。",
    },
    button: {
      create: "建立家庭",
      join: "加入家庭",
      faq: "常見問題",
      video: "教學影片",
      invite: "邀請建立家庭",
      email: "電郵",
      send: "發送",
      cancel: "取消",
    },
    confirmCreate: {
      message: "請確認建立家庭",
      confirm: "建立"
    }
  },
  join: {
    heading: "加入家庭",
    text: {
      info: "請輸入家庭資訊",
      expired: "加入連結已過期",
      incorrect: "加入連結不正確",
      recaptcha: "reCAPTCHA 暫時停用",
    },
    label: {
      adminEmail: "管理員電郵",
      code: "家庭驗證碼",
      nickname: "您的暱稱",
      role: "家庭角色",
      familyRef: "家庭編號",
    },
    button: {
      submit: "完成",
      back: "返回",
    },
    placeholder: {
      nickname: "最多100個字元",
    },
    validation: {
      adminEmailIsEmpty: "請輸入家庭管理員電郵地址。",
      codeIsInvalid: "家庭驗證碼格式不正確，請重新輸入。",
      codeIsEmpty: "請輸入家庭驗證碼。",
      nicknameIsEmpty: "請輸入暱稱。",
      roleIsEmpty: "請選擇家庭角色。",
      roleIsInvalid: "家庭角色不正確，請重新選擇。",
      adminEmailFormatWrong: "電郵地址格式不正確，請重新輸入。",
      adminEmailNotFound: "找不到此家庭管理員電郵地址。",
      codeNotMatch: "輸入的家庭驗證碼與輸入的家庭管理員的家庭驗證碼不相符。",
      groupNotFound: "找不到對應的家庭",
      nicknameBadword: "切勿使用不雅用語，請輸入其他暱稱。",
      nicknameExceedMax: "請輸入最多100個字元。",
      familyRefIsEmpty: "請輸入家庭編號。",
      familyRefExceedMax: "請輸入最多10個字元。",
    }
  },
  hold: {
    info: "24小時内已嘗試提交錯誤申請5次，請在{displayDatetime}之後再嘗試。"
  },
  request: {
    text: {
      info: "您可以撤回家庭管理員未處理的請求或被拒絕的請求",
      wait: "有關訊息已發到家庭管理員， 正在等候管理員同意。",
      decline: "管理員拒絕了加入的請求。",
      kick: "管理員已將您從家庭中移除。",
      dismiss: "管理員解散了家庭。",
      group: "家庭資訊",
    },
    button: {
      cancel: "取消申請",
      acknowledged: "我知道了",
      refresh: "重新整理",
    },
    confirmWidthdraw: {
      message: "撤回加入此家庭的請求？",
    },
  },
  details: {
    text: {
      dismissed: "此家庭已經被解散了，請按離開家庭。",
      editDialogTitle: "修改資料",
      copied: "已複製加入連結。",
      updated: "已修改資料。",
      expired: "家庭加入超鏈結已逾期，請於刷新後再次複製。",
      regened: "已刷新家庭加入超鏈結。",
      left: "您已離開家庭。",
      notMember: "您已離開家庭。",
      beKicked: "您已被管理員從家庭中移除。",
      dismiss: "此家庭已經被解散。",
      memberUpdated: "已修改您的成員資料。",
      accepted: "已接受成員加入此家庭。",
      declined: "已拒絕成員加入此家庭。",
      kicked: "此成員已被管理員從家庭中移除。",
      kickout: "此成員已離開此家庭。",
      withdrawn: "用戶已撤回加入請求。",
      processed: "請求已被處理。",
      handled: "不能撤回已處理的請求。",
      upgraded: "成員已被列為管理員。",
      downgraded: "已取消此成員的管理員身分。",
      acceptedAndUpgraded: "已接受用戶加入此家庭並將其列為管理員。",
      notAdmin: "您已被取消管理員權限。",
      singleAdmin: "由於每個家庭必須有至少一 個管理員，此操作無法執行。",
      multipleAdmin: "由於有多名家庭管理員，此操作無法執行。",
      notUpgrade: "此成員已經是家庭管理員。",
      notDowngrade: "此成員已不再是管理員。",
      shareInfo: "可透過發送連結或掃描二維碼加入家庭。",
      addChildInfo: "填寫學生登入信息，即可新增您的家庭成員。",
      expiredEmail: "家庭加入超鏈結已逾期，請刷新後再發送邀請電郵。",
      expiredWhatsapp: "家庭加入超鏈結已逾期，請刷新後再發送WhatsApp邀請連結。",
      member: "家庭成員 {nickname}",
      cannotDismiss: "由於此家庭有多於一個管理員，無法使用此功能。",
      cannotLeave: "由於家庭只有一個管理員，無法使用此功能。",
      error: "發生問題。",
      requestNotFound: "找不到對應的請求。",
      memberNotFound: "找不到對應的成員。",
      cannotJoin: "成員未能加入家庭。",
      cannotJoinNotStudent: "成員未能加入家庭。此功能只供學生會員使用，請使用加入超鏈結再嘗試。",
      joined: "成員已經加入家庭。",
      join: "成員加入家庭。",
    },
    label: {
      familyName: "家庭名稱",
      createDate: "家庭驗證碼生成日期",
      expiryDate: "家庭加入超鏈結到期日期",
      request: "請求",
      member: "成員",
      role: "家庭角色",
      status: "狀態",
      actions: "行動",
      expired: "已過期",
      you: "您",
      dismissed: "已解散",
      admin: "管理員",
      person: "人",
      memberList: "成員列表",
      requestList: "請求列表",
      receiverEmail: "收件人電郵",
      familyRef: "家庭編號",
      nickname: "您的暱稱",
      editRole: "家庭角色",
      code: "家庭驗證碼",
      loginInfo: "學生登入名稱",
      loginId: "電郵 / 登入名稱",
      accountPassword: "學生帳戶密碼",
      password: "輸入密碼",
    },
    placeholder: {
      nickname: "最多只能100個字母",
    },
    validation: {
      familyNameIsEmpty: "請輸入家庭名稱。",
      familyNameBadword: "切勿使用不雅用語，請輸入其他家庭名稱。",
      familyNameExceedMax: "輸入長度超過限制。",
      roleIsEmpty: "請選擇家庭角色。",
      roleIsInvalid: "家庭角色不正確，請重新選擇。",
      nicknameIsEmpty: "請輸入暱稱。",
      nicknameBadword: "切勿使用不雅用語，請輸入其他暱稱。",
      nicknameExceedMax: "輸入長度超過限制。",
      receiverEmailIsEmpty: "請輸入收件人電郵地址。",
      receiverEmailFormatWrong: "電郵地址格式不正確，請重新輸入。",
      cityIdIsEmpty: "請輸入登入名稱。",
      passwordIsEmpty: "請輸入登入密碼。",
    },
    button: {
      update: "修改家庭名稱",
      regenerate: "刷新加入超鏈結",
      dismiss: "解散家庭",
      leave: "退出家庭",
      edit: "編輯資料",
      cancel: "取消",
      previous: "上一頁",
      next: "下一頁",
      share: "複製加入超鏈結",
      familyInfo: "邀請成員",
      addChild: "加入孩子",
      refresh: "重新整理",
      confirm: "確定",
      acceptMember: "允許加入",
      declineMember: "拒絕加入",
      kick: "移除成員",
      upgrade: "授予管理員權限",
      downgrade: "取消其管理員身分",
      acceptAndUpgrade: "允許加入並授予管理員權限",
      send: "發送",
      invite: "邀請",
      email: "電郵",
      execute: "修改",
      copy: "複製邀請連結",
      yes: "是",
      no: "否",
      decline: "拒絕",
      join: "加入家庭",
    },
    confirmRegenerate: {
      message: "確認刷新家庭加入超鏈結？"
    },
    confirmAccept: {
      message: "允許{nickname}加入家庭？"
    },
    confirmDecline: {
      message: "拒絕{nickname}加入此家庭？"
    },
    confirmKick: {
      message: "確認將此成員{nickname}從家庭中移除？",
    },
    confirmDismiss: {
      message: "確認解散此家庭？",
    },
    confirmLeave: {
      message: "確認離開此家庭？",
    },
    confirmUpgrade: {
      message: "確認將此成員{nickname}列為管理員？",
    },
    confirmDowngrade: {
      message: "確認取消此成員{nickname}的管理員身分？",
    },
    confirmAcceptAndUpgrade: {
      message: "接受此成員{nickname}加入家庭並授予此成員管理員權限？",
    },
    share: {
      title: "我邀請您於教城加入家庭",
      content: "我想邀請您於香港教育城（教城）加入一個家庭。",
      email: {
        subject: "{fullname} 想邀請您於教城加入家庭",
        content: "您好! \n \n 為提升親子學習交流，我想邀請您於香港教育城（教城）加入一個家庭。要了解教城更多，點擊以下連結： \n https://www.edcity.hk/hq/zh-hant/content/aboutus \n 如您尚未有教城帳戶，請點擊以下連結申請： \n https://www.edcity.hk/hq/zh-hant/content/membership/public \n 如您已有教城的帳戶，請點擊以下連結，登入帳戶後即可加入家庭：\n {familyLink} \n \n 您的家庭成員 \n {fullname}",
      },
    },
  },
  share: {
    title: "我邀請您於教城建立家庭",
    content: "我想邀請您於香港教育城（教城）建立一個家庭。",
    email: {
      subject: "{fullname} 想邀請您於教城建立家庭",
      content: "您好! \n \n 為提升親子學習交流，我想邀請您於香港教育城（教城）建立一個家庭。要了解教城更多，請點擊以下連結： \n https://www.edcity.hk/hq/zh-hant/content/aboutus \n 如您尚未有教城帳戶，請點擊以下連結登記： \n https://www.edcity.hk/hq/zh-hant/content/membership/public \n 如您已有教城的帳戶，請點擊以下連結，登入帳戶後即可建立家庭：\n {familyLink} \n \n 您的家庭成員 \n {fullname}",
    },
  },
  multiple: {
    heading: "發現不同帳戶加入不同家庭",
    title: "請保留一個家庭",
    text: {
      success: "成功保留家庭。",
      error: "發生問題，未能保留家庭。",
    },
    button: {
      keep: "保留此家庭",
    },
    confirmKeep: {
      message: "確認保留此家庭 {groupName}？",
    },
  },
};
